import { ReportType } from 'generated/graphql';

export const REPORT_TYPES: Record<ReportType, string> = {
  [ReportType.Finoptio]: 'Finoptio',
  [ReportType.Fintelligence]: 'Fintelligence',
};

export const REPORT_TYPE_CHOICES = Object.entries(REPORT_TYPES)
  .map(([id, name]) => ({ id, name }))
  .sort((a, b) => a.name.localeCompare(b.name));
